module.exports = __webpack_public_path__ + "71b71afc894df3c89ebc4b26d45672e2.jpg";